import React, { Fragment } from "react";
import { renderTextField, renderSelect } from "../../ReduxFormAdapters";
import { MenuItem, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import DateField from "../../Helpers/DateField";
import ValidatedField from "../../Helpers/FieldValidator/ValidatedField";

const ProfileFields = (props) => {
    const { working, student, landlord, form, preferred } = props;
    const tenant = !landlord;
    return (
        <Fragment>
            {!preferred &&
                <ValidatedField
                    name="firstName"
                    component={renderTextField}
                    required
                    type="text"
                    label="Your First Name*"
                />
            }
            {!preferred &&
                <ValidatedField
                    name="lastName"
                    component={renderTextField}
                    required
                    type="text"
                    label="Your Last Name*"
                />
            }
            {!preferred &&
                <ValidatedField
                    name="phoneNumber"
                    component={renderTextField}
                    type="text"
                    label="Phone Number*"
                />
            }
            <ValidatedField
                name="industries"
                component={renderSelect}
                multiple
                label="Industry*"
                required
            >
                <MenuItem disabled value="">Select your preferable industry type</MenuItem>
                <MenuItem value="mn">Manufacturing</MenuItem>
                <MenuItem value="fi">Financial services</MenuItem>
                <MenuItem value="tr">Transportation</MenuItem>
                <MenuItem value="ed">Education</MenuItem>
                <MenuItem value="ti">Tiertiary industry</MenuItem>
                <MenuItem value="hc">Health care</MenuItem>
                <MenuItem value="ht">Hospitality</MenuItem>
                <MenuItem value="mi">Media industry</MenuItem>
                <MenuItem value="ot">Other</MenuItem>


            </ValidatedField>



            {/*{ !preferred &&
                <ValidatedField
                    container={DateField}
                    name="birthday"
                    form={form}
                    label="Birthday"
                    year
                    future
                />
            }
            */}


            {/*  { preferred &&
                <ValidatedField
                    name="companyName"
                    component={renderTextField}
                    type="text"
                    label="Time in finlan"
                />
            }
             */}

            {/* { ( tenant || preferred ) &&
                <ValidatedField
                    name="occupation"
                    component={renderSelect}
                    multiple
                    label="Occupation"
                >
                    <MenuItem disabled value="">{preferred ? "Select preferred occupation, if any" : "Select those that match your current occupation"}</MenuItem>
                    <MenuItem value="work">Working</MenuItem>
                    <MenuItem value="student">Student</MenuItem>
                </ValidatedField>
            }
           */}


            {(tenant && working) &&
                <ValidatedField
                    name="workDetails"
                    component={renderTextField}
                    type="text"
                    label="Work details"
                />
            }
            {(tenant && student) &&
                <ValidatedField
                    name="studentDetails"
                    component={renderTextField}
                    type="text"
                    label="Study details"
                />
            }

            {/*{ ( !preferred && tenant ) &&
                <ValidatedField
                    name="currentAddress"
                    component={renderTextField}
                    type="text"
                    label="Current Address"
                />
            }
            */}


        </Fragment>
    );
}

export default connect(
    (state, ownProps) => {
        const selector = formValueSelector(ownProps.form || (ownProps.landlord ? "landlordSignup" : "signup"));
        const occupation = selector(state, "occupation");
        return {
            working: occupation
                ? (Array.isArray(occupation)
                    ? occupation.includes("work")
                    : (occupation.work ? true : false))
                : false,
            student: occupation
                ? (Array.isArray(occupation)
                    ? occupation.includes("student")
                    : (occupation.student ? true : false))
                : false,
            ...ownProps
        }
    },
    dispatch => ({
        dispatch: dispatch
    })
)(ProfileFields);